export const createEmailService = `
mutation MyMutation(
  $hotelId: String!
  $name: String!
  $fromName: String!
  $fromAddress: String!
  $subject: String!
  $templateType: String!
  $audience: EmailAudienceInput!
  $htmlTemplateBody: String
  $lang: String
  $cc: String
  $bcc: String
) {
  createEmailService(
    input: {
      hotelId: $hotelId
      name: $name
      fromName: $fromName
      fromAddress: $fromAddress
      subject: $subject
      templateType: $templateType
      audience: $audience
      htmlTemplateBody: $htmlTemplateBody
      lang: $lang
      cc: $cc
      bcc: $bcc
    }
  ) {
    audience {
      guests {
        blockCodes { logic values }
        loyaltyTiers { logic values }
        roomTypes { logic values }
        rooms { logic values }
      }
      staff { emails }
      type
    }
    bcc
    cc
    createdAt
    createdBy
    fromAddress
    fromName
    hotelId
    htmlTemplateBody
    id
    isPublished
    name
    subject
    version
    updatedBy
    updatedAt
    templateType
  }
}
`;

export const updateEmailService = `
mutation MyMutation(
  $id: String!
  $hotelId: String!
  $name: String!
  $fromName: String!
  $fromAddress: String!
  $subject: String!
  $templateType: String!
  $audience: EmailAudienceInput!
  $bcc: String
  $cc: String
  $htmlTemplateBody: String
  $isPublished: Boolean
  $lang: String
) {
  updateEmailService(
    input: {
      id: $id
      hotelId: $hotelId
      name: $name
      fromName: $fromName
      fromAddress: $fromAddress
      subject: $subject
      templateType: $templateType
      audience: $audience
      bcc: $bcc
      cc: $cc
      htmlTemplateBody: $htmlTemplateBody
      isPublished: $isPublished
      lang: $lang
    }
  ) {
    id
  }
}
`;

export const updateEmailServiceTemplate = `
mutation MyMutation(
  $bcc: String
  $cc: String
  $fromAddess: String!
  $fromName: String!
  $hotelId: String!
  $id: String!
  $name: String!
  $subject: String!
  $emailTemplate: EmailTemplateInput
  $lang: String
  ) {
  updateEmailService(input:
    {
    bcc: $bcc
    cc: $cc
    fromAddess: $fromAddess
    fromName: $fromName
    hotelId: $hotelId
    id: $id
    name: $name
    subject: $subject
    emailTemplate: $emailTemplate
    lang: $lang
  })
     {
    id
  }
}
`;

export const deleteEmailServiceTemplate = `
mutation MyMutation($hotelId: String!, $id: String!, $lang: String) {
  deleteEmailService(input: { hotelId: $hotelId, id: $id, lang: $lang
   }) {
    message
    status
  }
}
`;

export const publishEmailServiceTemplate = `
mutation MyMutation($hotelId: String!, $id: String!, $lang: String) {
  publishEmailService(input: { hotelId: $hotelId, id: $id, lang: $lang
   }) {
    message
    status
  }
}
`;

export const unPublishEmailServiceTemplate = `
mutation MyMutation($hotelId: String!, $id: String!, $lang: String) {
  unpublishEmailService(input: { hotelId: $hotelId, id: $id ,lang: $lang}) {
    message
    status
  }
}
`;

export const sendEmailMutation = `
  mutation SendEmail($input: SendEmailInput!) {
    sendEmail(input: $input) {
      status
      message
    }
  }
`;
